import { render, staticRenderFns } from "./online_users.vue?vue&type=template&id=16980e72"
import script from "./online_users.vue?vue&type=script&lang=js"
export * from "./online_users.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports